import React, { ReactElement } from "react"

import RocketIcon from "src/assets/icons/rocket-black.svg"
import { Box, BoxProps } from "@mui/material"
import Text from "../Text"

export default function BoostedTag(props: BoxProps): ReactElement {
  return (
    <Box
      p={1}
      display="flex"
      gap={0.5}
      alignItems="center"
      sx={{
        backgroundColor: "#00A68C",
        borderRadius: "8px",
      }}
      {...props}
    >
      <img src={RocketIcon} height={12} />
      <Text bold size="micro" color="#000000">
        Boosted
      </Text>
    </Box>
  )
}
